module.exports = __webpack_public_path__ + "img/doc-playbtn.49fd6ac8.jpg";